import {isString} from 'lodash';

interface ICustomRule {
  valueLabel: string;
}

const customRules: Record<string, ICustomRule> = {};

export const setCustomRule = (id: string, value: ICustomRule) => {
  customRules[id] = value;
};

export const getCustomRuleById = (id?: string) => {
  return customRules?.[id ?? ''];
};

export const deleteCustomRuleById = (id?: string) => {
  delete customRules?.[id ?? ''];
};

export const processRules = (data: any) => {
  let counter = 1;

  const transform = (items: any) => {
    return items.map((item: any) => {
      if (isString(item)) {
        return item.toLocaleUpperCase();
      }

      if (item.rules) {
        if (item.rules.length === 0) {
          return '()';
        }
        return `(${transform(item.rules).join(' ')})`;
      }

      return counter++;
    });
  };

  return transform(data).join(' ');
};
